import React from 'react';

const SuccessIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="12" fill="#265148" />
    <g clipPath="url(#clip0_640_5003)">
      <path
        d="M9.50001 15.4749L6.02501 11.9999L4.84167 13.1749L9.50001 17.8332L19.5 7.8332L18.325 6.6582L9.50001 15.4749Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_640_5003">
        <rect width="20" height="20" fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
  </svg>
);

export default SuccessIcon;
